import BaseTrackingView from '../../core/baseTrackingView';

export default BaseTrackingView.extend({

    events: {
        'click .checkout-buy': 'onBuyClick'
    },

    onBuyClick: function () {
        if (typeof window.dataLayer !== 'undefined') {
            window.dataLayer.push({
                event: 'buy_clicked'
            });
        }
    }

});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/tracking/checkout/Index.js
 **/